import { Signin } from "views/signin";
import { Players } from "@/views/players";
import Coaches from "@/views/coaches";
import Applications from "@/views/applications";

const Routes = [
  {
    path: "/",
    view: Signin,
    layout: "auth",
    title: "Mission Control",
  },
  {
    path: "/signin",
    view: Signin,
    layout: "auth",
    title: "Mission Control",
  },
  {
    path: "/players",
    view: Players,
    layout: "app",
    permission: "master",
    title: "Manage Players",
  },
  {
    path: "/coaches",
    view: Coaches,
    layout: "app",
    permission: "master",
    title: "Manage Coaches",
  },
  {
    path: "/applications",
    view: Applications,
    layout: "app",
    permission: "master",
    title: "Manage Applications",
  },
];

export default Routes;
